import service from "@/store/services/folders-service";

export const state = () => ({
  list: {},
  folder: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, folder) => {
    state.folder = folder;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((folder) => {
      commit("SET_RESOURCE", folder);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((folder) => {
      commit("SET_RESOURCE", folder);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((folder) => {
      commit("SET_RESOURCE", folder);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  folder: (state) => state.folder,
  url: (state) => state.url,
};

const folders = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default folders;
